import React from "react";
import logo from "../../images/logo2.svg";

const RootLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#162c2a] w-screen h-screen">
      {/* Pharmacy cross pattern background — same as SubNavbar */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "40px 40px",
        }}
      />

      {/* Soft teal radial glow behind logo */}
      <div className="absolute w-[320px] h-[320px] rounded-full bg-[#5fbdb3]/10 blur-3xl pointer-events-none" />

      {/* Logo */}
      <div className="relative flex flex-col items-center gap-8">
        <img src={logo} alt="MediSYS" className="w-44 h-auto animate-pulse" />

        {/* Loading bar */}
        <div className="w-40 h-1 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-[#5fbdb3] to-[#ff601e] animate-[loading-bar_1.6s_ease-in-out_infinite]" />
        </div>

        {/* Text */}
        <p className="text-[13px] font-medium font-poppins text-white/40 tracking-widest uppercase animate-pulse">
          Loading…
        </p>
      </div>

      {/* Tailwind keyframe for loading bar — injected via style tag */}
      <style>{`
        @keyframes loading-bar {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(0%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default RootLoader;
